import { useRouter } from 'next/router';

import { usePayFlow } from '@/v2/domains/Payments/flows/Pay/usePayFlow.hook';
import useGetSubscriptionQuery from '@/v2/domains/Subscriptions/queries/useGetSubscriptionQuery.hook';

import { useManageSubscriptionStore } from '../stores/useManageSubscription.store';
import type { SubscriptionType } from '../types/subscription';

export default function useManageSubscriptionActions() {
  const router = useRouter();
  const { setInPageAction } = useManageSubscriptionStore();
  const { start } = usePayFlow();
  const { data: existingSubscription } = useGetSubscriptionQuery();

  const openBillingHistory = () => {
    setInPageAction('billingHistory');
  };

  const openChangePaymentMethod = () => {
    setInPageAction('changePaymentMethod');
  };

  const openCancelSubscription = () => {
    setInPageAction('cancelSubscription');
  };

  const openReactivateSubscription = () => {
    setInPageAction('reactivateSubscription');
  };

  const showPlans = () => {
    router.push('/settings/manageSubscription/change');
  };

  const subscribe = () => {
    showPlans();
  };

  const upgrade = (subscriptionType: SubscriptionType) => {
    start({ subscriptionType, existingSubscription });
  };

  const renew = () => {
    start({
      subscriptionType: existingSubscription.subscriptionType,
      existingSubscription,
    });
  };

  return {
    openBillingHistory,
    openChangePaymentMethod,
    openCancelSubscription,
    openReactivateSubscription,
    subscribe,
    upgrade,
    renew,
    showPlans,
  };
}
